export default "__VITE_ASSET__fdWwiGur__"